<section class="page">
  <header class="page-header">
    <h2>Uploader des fichiers Antagène</h2>
    <p class="subtitle">Formats autorisés: .xlsx, .fasta, .fa</p>
  </header>

  <section class="panel">
    <label class="field">
      Fichiers Antagène
      <input
        type="file"
        (change)="onFileChange($event)"
        [disabled]="loading"
        accept=".xlsx,.fasta,.fa"
        multiple
      />
    </label>

    @if (selectedFiles.length > 0) {
      <p class="meta">{{ selectedFiles.length }} fichier(s) sélectionné(s)</p>
      <ul class="file-list">
        @for (file of selectedFiles; track file.name + '-' + file.size) {
          <li>{{ file.name }}</li>
        }
      </ul>
    }

    <button type="button" (click)="upload()" [disabled]="loading || selectedFiles.length === 0">
      {{ loading ? 'Upload en cours...' : 'Uploader' }}
    </button>

    @if (success) {
      <pre class="success">{{ success }}</pre>
    }

    @if (error) {
      <pre class="error">{{ error }}</pre>
    }
  </section>

  <section class="panel">
    <h3>10 derniers fichiers importés</h3>
    <button type="button" (click)="refreshFiles()" [disabled]="filesLoading" class="btn-secondary">
      {{ filesLoading ? 'Chargement...' : 'Rafraîchir' }}
    </button>

    @if (filesError) {
      <p class="error">{{ filesError }}</p>
    }

    @if (filesLoading) {
      <p class="meta">Chargement de la liste...</p>
    } @else if (existingFiles.length === 0) {
      <p class="meta">Aucun fichier trouvé.</p>
    } @else {
      <ul class="file-list">
        @for (item of existingFiles; track $index) {
          <li>{{ item.name }}</li>
        }
      </ul>
    }
  </section>
</section>
